import styled from 'styled-components';
import { ButtonIconMixin } from '../../mixins/components/ButtonIconMixin';
var ButtonIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "ButtonIcon",
  componentId: "c11n-8-111-1__sc-tkmq02-0"
})(["", ""], ButtonIconMixin);
ButtonIcon.displayName = 'ButtonIcon';

/** @component */
export { ButtonIcon };